import { strings } from "intl/fa";
import styles from "./Login.module.scss";
import { BaleFlatLogoTypo } from "@bale/ui";
import PhoneEntrance from "./phoneEntrance/PhoneEntrance";
import { useLayoutEffect, useMemo } from "react";
import OtpEntrance from "./otpEntrance/OtpEntrance";
import Register from "./register/Register";
import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import { AuthState } from "../../../core/auth/auth.slice";
import { useAppSelector } from "../../../utils/store";
import RedirectToMain from "./RedirectToMain";
import { useRequest } from "../../../hooks/useRequest";
import { getTokenThunk } from "../../../core/auth/auth.thunk";
import { useLocation } from "react-router-dom";

const Login = () => {
  const authState = useAppSelector((state) => state.auth.authState);
  const { sendRequest } = useRequest(getTokenThunk);
  const search = useLocation().search;
  useLayoutEffect(() => {
    const params = new URLSearchParams(search);
    const otp = params.get("o");
    const phone = params.get("p");
    if (phone && otp) {
      sendRequest({ otp, phoneFromParams: phone });
    }
  }, []);
  const CurrentPhase = useMemo(() => {
    switch (authState) {
      case AuthState.PhoneEntrance:
        return <PhoneEntrance />;
      case AuthState.OtpEntrance:
        return <OtpEntrance />;
      case AuthState.OtpSmsEntrance:
        return <OtpEntrance withSms />;
      case AuthState.Register:
        return <Register />;
      case AuthState.BaleRegister:
        return <Register baleSignUp />;
      case AuthState.Success:
        return <RedirectToMain />;
    }
  }, [authState]);

  return (
    <div className={styles.container}>
      <CardWrapper
        center
        noScroll
        className={styles.Card}
        title={strings.login.header}
      >
        {CurrentPhase}
      </CardWrapper>
      <div className={styles.sidebox}>
        <p className={styles.description}>{strings.login.description}</p>
        <BaleFlatLogoTypo className={styles.BaleFlatLogoTypo} size={0} />
      </div>
    </div>
  );
};

export default Login;
